export const asObjectIcon = {
  data: `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 75.406 75.406" fill="currentColor">
      <path d="M63.952,35.436V7.755H0v27.682L63.952,35.436L63.952,35.436z M2.863,32.573V10.618H61.09v21.955H2.863z M63.952,70.275   V42.595H26.488v27.682L63.952,70.275L63.952,70.275z M29.351,67.412V45.457h31.737v21.955H29.351z M70.395,0.835h5.012v73.736   h-5.012V0.835z"/>
    </svg>
  `,
  name: 'outline/object'
}; 